module.exports = __webpack_public_path__ + "static/dsunny-6a8744483de52fc87b47d06ced503887.jpeg";